import { ServerResponse } from '../serverResponse';
import { FinnOccupation } from './FinnOccupation';
import { FinnContact } from './FinnContact';
import { FinnIndustry } from './FinnIndustry';
import { FinnTag } from './FinnTag';
import { FinnDuration } from './FinnDuration';

export class FinnAdvertisement extends ServerResponse {
  job_id: number;

  // company fields
  company_name: string; // defaults to company.name
  ingress: string; // defaults to value of company.description
  industries: FinnIndustry[] = [];
  company_url: string;
  company_facebook_url: string;
  company_linkedin_url: string;
  company_twitter_url: string;

  // Job fields
  position: string; // title of ad
  heading: string; // Short description of job, displayed in job posting list on Finn.no
  general_text: string;
  duration: string; // Defaults to first value of DURATION fetched from Finn.no
  sector: string; // Defaults to first value of SECTOR fetched from Finn.no
  num_positions: number; // Defaults to 1
  occupations: FinnOccupation[] = []; // An ad can have up to 3 occupations
  tags: FinnTag[] = []; // An ad can have up to 5 tags.
  video_url: string; // URL to video embedded in ad
  salary: string;
  due_date: string;
  finn_form_tag_desc: string;
  sectors?: any[];
  durations?: FinnDuration[];

  // Address fields
  address: string;
  zip_code: string;
  city: string;

  // Contact fields
  contacts: FinnContact[] = []; // Assigned contact for FinnAdvertisement

  // urls assigned upon creation of FinnAdvertisement
  ad_url: string;
  statistics_url: string;

  // status
  stopped: boolean;
  validated: boolean;

  constructor(jobId) {
    super();
    this.job_id = jobId;
    this.num_positions = 1;
  }
}
